import React from 'react';
import HeaderSection from '../../components/reusableComponents/HeaderSection';

const Contact = () => {
	return (
		<>
			<HeaderSection id={1} />
			<div style={{ padding: 76 }}>
				<section className='footer'>
					<div className='box-container'>
						<div className='box' data-aos='fade-up'>
							<h3>DHANBAD</h3>
							<p>+91 8877773388</p>
							<p>1st Floor,New Tech Grand, Bank More, Dhanbad-826001</p>
						</div>
						<div className='box' data-aos='fade-up'>
							<h3>DELHI</h3>
							<p>+91 8877773388</p>
							<p>1st Floor,New Tech Grand, Bank More, Dhanbad-826001</p>
						</div>
						<div className='box' data-aos='fade-up'>
							<h3>DUBAI</h3>
							<p>+91 8877773388</p>
							<p>1st Floor,New Tech Grand, Bank More, Dhanbad-826001</p>
						</div>
					</div>
				</section>
			</div>
			<div style={{ padding: 76 }}>
				<section className='footer'>
					<div className='box-container'>
						{/* <iframe
							src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1825.098071274814!2d86.4562200880896!3d23.811623313894234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f6bc838589c90d%3A0x9d43d05a13d9848e!2sMusafirBazar.Com!5e0!3m2!1sen!2sin!4v1571913862306!5m2!1sen!2sin'
							width='100%'
							height='300'
							frameborder='0'
							style='border:0;'
							allowfullscreen=''></iframe> */}
					</div>
				</section>
			</div>
			<section className='footer'>
				<div className='box-container'>
					<div className='box' data-aos='fade-up'>
						<h3>Musafir Bazar</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Info
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Privacy Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Terms & Condition
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Careers
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i>
							About Us
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Products</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Flight Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Bus Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Hotel Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Holiday Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Car Booking
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Contact Info</h3>
						<a href='#'>
							<i className='fas fa-phone'></i> +91 887-777-3388
						</a>
						<a href='#'>
							<i className='fas fa-envelope'></i>sales@musafirbazar.com
						</a>
						<a href='#'>
							<i className='fas fa-map-marker-alt'></i>1st Floor,New Tech Grand,
							Bank More, Dhanbad-826001
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Follow Us</h3>
						<a href='https://www.facebook.com/musafirbazaar' target='_blank'>
							<i className='fab fa-facebook-f'></i> facebook
						</a>
						<a href='https://twitter.com/musafirbazar' target='_blank'>
							<i className='fab fa-twitter'></i> twitter
						</a>
						<a href='https://www.instagram.com/musafirbazar/' target='_blank'>
							<i className='fab fa-instagram'></i> instagram
						</a>
						<a
							href='https://www.linkedin.com/company/musafirbazar'
							target='_blank'>
							<i className='fab fa-linkedin'></i> linkedin
						</a>
						<a href='#'>
							<i className='fab fa-pinterest'></i> pinterest
						</a>
					</div>
				</div>

				<div className='credit' style={{ fontSize: 14 }}>
					Copyright ©2022, All Rights Reserved. Powered by Arya Aviation India
					Pvt. Ltd.
				</div>
			</section>
		</>
	);
};

export default Contact;
